
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"レイヤー 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12 24a12 12 0 1112-12 12.013 12.013 0 01-12 12zm0-23a11 11 0 1011 11A11.013 11.013 0 0012 1z"}}),_c('path',{attrs:{"d":"M10.075 23.522a.5.5 0 01-.407-.209A19.829 19.829 0 016.43 12 19.821 19.821 0 019.671.689a.5.5 0 01.812.582A18.82 18.82 0 007.43 12a18.82 18.82 0 003.051 10.729.5.5 0 01-.406.791zm4.24 0a.492.492 0 01-.291-.094.5.5 0 01-.115-.7A18.81 18.81 0 0016.963 12a18.815 18.815 0 00-3.052-10.729.5.5 0 01.814-.582A19.833 19.833 0 0117.963 12a19.819 19.819 0 01-3.241 11.313.5.5 0 01-.407.209z"}}),_c('path',{attrs:{"d":"M22.455 8.318H1.545a.5.5 0 010-1h20.91a.5.5 0 010 1zm0 8.364H1.545a.5.5 0 110-1h20.91a.5.5 0 010 1z"}})])
          )
        }
      }
    